import { FC } from 'react';

import {
  activeStepStyle,
  containerStyle,
  stepStyle
} from '@/components/common/Steps/styles.ts';

interface StepsProps {
  count: number;
  progress: number;
}

export const Steps: FC<StepsProps> = ({ count, progress }) => (
  <div style={containerStyle}>
    {Array.from({ length: count }, (_, index) => (
      <div key={index} style={index < progress ? activeStepStyle : stepStyle} />
    ))}
  </div>
);

export const StepTitle: FC<{ title: string; subTitle?: string }> = ({
  title,
  subTitle
}) => (
  <p
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '1em'
    }}
  >
    <span style={{ display: 'block', fontSize: '24px', fontWeight: 590 }}>
      {title}
    </span>
    <span
      style={{
        display: 'block',
        fontSize: '14px',
        color: '#787878',
        fontWeight: 510
      }}
    >
      {subTitle}
    </span>
  </p>
);
